import { takeEvery, takeLatest } from "redux-saga/effects";
import { TestCall } from "../Slices/TestSlicers/TestApi";
import { EditUserPermissionCall } from "../Slices/UserPermission/UserPermissionAPI";
import { ListUserPermissionRowsCall } from "../Slices/UserPermission/UserPermissionAPI";
import {
  ForgotPasswordCall,
  GoogleLoginCall,
  LoginCall,
} from "../Slices/LoginSlicer/LoginApi";
import { ResetPasswordCall } from "../Slices/ResetPassword/ResetPasswordAPI";
import { SideMenuPermissionCall } from "../Slices/SideMenuPermission/ApiSideMenuPermission";
import { DashboardCardCall } from "../Slices/Dashboard/ApiDashboard";
import {
  AddExamHistoryCall,
  DeleteExamHistoryCall,
  EditExamHistoryCall,
  ListExamHistoryCall,
  ListExamHistoryReWritingSliceCall,
  ListMockExamHistoryCall,
} from "../Slices/ExamHistory/ApiExamHistory";
import {
  AddOptionsCall,
  DeleteOptionsCall,
  EditOptionsCall,
  ListOptionsCall,
} from "../Slices/Options/ApiOptions";
import {
  ListRegistrationYeargroupCall,
  RegistrationCall,
} from "../Slices/Registration/RegistrationApi";
import {
  AddMenuCall,
  DeleteMenuCall,
  EditMenuCall,
  ListMenuCall,
} from "../Slices/Menu/ApiMenu";
import { getRolesScreenlistApiCall, getScreenListApiCall } from "../Slices/Screen/ApiScreen";
import {
  AddInstructionCall,
  DeleteInstructionCall,
  EditInstructionCall,
  ListInstructionCall,
} from "../Slices/Instruction/ApiInstruction";
import {
  AddExamAnswerCall,
  DeleteExamAnswerCall,
  EditExamAnswerCall,
  ListExamAnswerCall,
  ListExamsubmitCall,
  ListExamsubmitoverallCall,
} from "../Slices/ExamAnswer/ApiExamAnswerSlice";
import {
  AddQuestionTypeCall,
  DeleteQuestionTypeCall,
  EditQuestionTypeCall,
  GetQuestionSubTypeCall,
  ListDashboardPerformenceTrendCall,
  ListQuestionTypeCall,
  ListSubjectListCall,
} from "../Slices/QuestionType/ApiQuestionType";
import { ScheduleQuestionTypesCall } from "../Slices/QuestionType/ApiQuestionType";
import { ScheduledClassesCall } from "../Slices/ScheduledClasses/ApiScheduledClasses";
import { ScheduleSetupDataCall } from "../Slices/ScheduledClasses/ApiScheduleSetupData";
import { CreateMeetLinkCall } from "../Slices/ScheduledClasses/ApiCreateMeetLink";
import { CreateScheduledClassCall } from "../Slices/ScheduledClasses/ApiCreateScheduledClass";
import {
  AddyearGroupCall,
  DeleteyearGroupCall,
  EdityearGroupCall,
  ListyearGroupCall,
} from "../Slices/yearGroup/ApiyearGroup";

import {
  AddQuestionSubTypeCall,
  DeleteQuestionSubTypeCall,
  EditQuestionSubTypeCall,
  ListQuestionSubTypeCall,
  QuestionSubTypelistCall,
} from "../Slices/QuestionSubType/ApiQuestionSubType";
import {
  AddExamModelCall,
  DeleteExamModelCall,
  EditExamModelCall,
  ListExamModelCall,
} from "../Slices/ExamModel/ApiExamModel";
import {
  AddCloseSectionCall,
  AddExamCall,
  DeleteExamCall,
  EditExamCall,
  ListEvaluationCall,
  ListExamCall,
  ListExamIDCall,
  ListInstructionExamIDCall,
} from "../Slices/Exam/ApiExam";
import {
  AddStudentExamCall,
  EditStudentExamCall,
  ListStudentExamCall,
} from "../Slices/StudentExam/ApiStudentExam";
import {
  AddFeedBackCall,
  DeleteFeedBackCall,
  EditFeedBackCall,
  ListFeedBackCall,
} from "../Slices/FeedBack/ApiFeedBack";
import {
  AddPackageCall,
  DeletePackageCall,
  EditPackageCall,
  ListPackageCall,
  ListPackageDomainCall,
  ListPackagePeriodCall,
  ListSubscribedUserCall,
} from "../Slices/Package/ApiPackage";
import {
  AddUserCall,
  DeleteUserCall,
  EditUserCall,
  ListRegionCall,
  ListUserCall,
  ListYearGroupCall,
} from "../Slices/User/ApiUser";
import {
  AddQuestionsCall,
  DeleteQuestionsCall,
  EditQuestionsCall,
  ListQuestionsCall,
} from "../Slices/Questions/ApiQuestions";
import { BulkUploadQuestionsCall } from "../Slices/Questions/ApiBulkUploadQuestions";
import { QuestionMappingCall } from "../Slices/Questions/ApiQuestionMapping";
import { ListReExamIDCall } from "../Slices/ReExam/ApiReExam";
import { ListReViewExamIDCall } from "../Slices/ReViewExam/ApiReViewExam";
import {
  ChatbotPublicCall,
  ExamReadChatbotPublicCall,
  ExamWritingChatbotPublicCall,
  ReadChatbotPublicCall,
  WritingChatbotPublicCall,
} from "../Slices/ChatbotPublic/ChatbotPublicApi";
import {
  AddYearlevel_mapCall,
  DeleteYearlevel_mapCall,
  EditYearlevel_mapCall,
  ListYearlevel_mapCall,
} from "../Slices/Yearlevel_map/ApiYearlevel_map";
import {
  ListUserExamListCall,
  ListUserPackageCall,
  ListUserPackageDetailsCall,
  PendingExamListApiCall,
} from "../Slices/UserPackage/ApiPackage";
import { ListMockExamCall } from "../Slices/MockExam/ApiMockExam";
import { PendingExamCall } from "../Slices/PendingExam/ApiReExam";
import {
  AddCoursesCall,
  DeleteCoursesCall,
  EditCoursesCall,
  ListCoursesCall,
} from "../Slices/Courses/ApiPackage";
import {
  AddUserAdminCall,
  DeleteUserAdminCall,
  EditUserAdminCall,
  ListUserAdminCall,
} from "../Slices/UserAdmin/ApiUser";
import { GetTopicsCall } from "../Slices/TopicSelection/ApiPackage";

import {
  AddPracticeExamCall,
  DeletePracticeExamCall,
  EditPracticeExamCall,
  ListEvaluationPracticeCall,
  ListEvaluationPracticewritingExamCall,
  ListInstructionPracticeExamIDCall,
  ListPracticeExamCall,
  ListPracticeExamIDCall,
} from "../Slices/PracticeExam/ApiPracticeExam";
import { ListPracticeTestCall } from "../Slices/PracticeTest/ApiPracticeExam";
import { PendingPracticeExamCall } from "../Slices/PendingPracticeExam/ApiPendingPracticeExam";
import {
  AddStudentExamPracticeCall,
  EditStudentExamPracticeCall,
  ListStudentExamPracticeCall,
} from "../Slices/StudentExamPractice/ApiStudentExamPractice";
import {
  AddExamAnswerPracticeCall,
  ListExamAnswerPracticeCall,
  ListExamsubmitPracticeCall,
} from "../Slices/ExamAnswerPractice/ApiExamAnswerSlice";
import { ListReViewExamIDPracticeCall } from "../Slices/ReViewExamPractice/ApiReViewExamPractice";
import { AddFeedBackPracticeCall } from "../Slices/FeedBackPractice/ApiFeedBackPractice";
import {
  ListWritingExamAIPracticeSliceCall,
  ListWritingExamPracticeSliceCall,
} from "../Slices/Writing_Exam_Practice/ApiWritingExam";
import { ListReadingPromptCall } from "../Slices/ReadingPrompt/ApiReadingPrompt";
import { AddOpenSectionCall } from "../Slices/OpenSection/ApiOpenSection";
import { ListWritingExamAISliceCall } from "../Slices/Writing_Exam/ApiWritingExamAI";
import {
  AchievementsCall,
  DashboardCalenderDataCall,
  DashboardDataCardCall,
  Recommended_ActionCall,
} from "../Slices/DashboardData/ApiDashboardData";
import { DashboardweeklyprefCall } from "../Slices/DashboardData/ApiDashboardData";

import { DashboardChartCall } from "../Slices/DashboardChart/ApiDashboardChart";
import {
  AddSettingCall,
  ListSettingResetCall,
  ListSettingResetMockApiCall,
} from "../Slices/Setting/ApiSetting";
import { AddArithmeticGameSkillCall } from "../Slices/ArithmeticGameSkill/ApiArithmeticGameSkill";
import { AddMemoryGameSkillCall } from "../Slices/MemoryGameSkill/ApiMemoryGameSkill";
import {
  AddSubscriptionCall,
  DeleteSubscriptionCall,
  ListSubscriptionCall,
} from "../Slices/Subscription/ApiSubscription";
import { ListBillingCall } from "../Slices/Billing/ApiBilling";
import {
  AddSubscribedMapCall,
  DeleteSubscribedMapCall,
  EditSubscribedMapCall,
  ListSubscribedMapCall,
} from "../Slices/SubscribedMap/ApiSubscribedMap";
import {
  AddSubjectMobileCall,
  DeleteSubjectMobileCall,
  EditSubjectMobileCall,
  ListSubjectMobileCall,
} from "../Slices/SubjectMobile/ApiSubjectMobile";
import {
  AddSubtopicMobileCall,
  DeleteSubtopicMobileCall,
  EditSubtopicMobileCall,
  ListSubtopicMobileCall,
} from "../Slices/SubtopicMobile/ApiSubtopicMobile";
import {
  AddContentMobileCall,
  DeleteContentMobileCall,
  EditContentMobileCall,
  ListContentMobileCall,
} from "../Slices/ContentMobile/ApiContentMobile";
import {
  AddCreategoalsCall,
  ListDailygoalsCall,
  ListDashboardprogressCall,
  ListPerformanceCall,
  ListPrefmanceTrendCall,
  ListQuestionBankCall,
  ListRecentActivityCall,
} from "../Slices/NewDashboardAPI/ApiNewDashboard";

import {
  AddCountryCall,
  DeleteCountryCall,
  EditCountryCall,
  ListCountryCall,
} from "../Slices/Country/ApiCountry";

import {
  AddRoleCall,
  DeleteRoleCall,
  EditRoleCall,
  ListRoleCall,
} from "../Slices/Role/ApiRole";
import {
  ListCountryListCall,
  ListStateCall,
} from "../Slices/ExterAPI/ApiCountryandState";
import { ListReExamPracticeIDCall } from "../Slices/ReExamPractice/ApiReExamPractice";
import {
  AddExamdateCall,
  DeleteExamdateCall,
  EditExamdateCall,
  ListExamdateCall,
} from "../Slices/Examdate/ApiRole";
import { ListdaycalculationCall } from "../Slices/day_calculation/Apidaycalculation";
import { AddFalgCall, ListFlagCall } from "../Slices/Falg/ApiFalg";

import {
  ListStudyContentSliceCall,
  ListStudyNoteSubjectSliceCall,
  ListStudyNoteSubjectTopicSliceCall,
  ListStudyNoteSubjectTopicSubSliceCall,
} from "../Slices/StudyNote/ApiStudyNote";
import { AddSupportCall } from "../Slices/Support/ApiSupport";
import { ListFAQCall } from "../Slices/Support/ApiFAQ";
import {
  AddFalgExamCall,
  ListFlagExamCall,
  ListFlagExamSubmissionCall,
} from "../Slices/FalgExam/ApiFalgExam";
import { ChatbotCall, WritingChatbotCall } from "../Slices/Chatbot/ChatbotApi";
import {
  AddVideoLessonCall,
  DeleteVideoLessonCall,
  EditVideoLessonCall,
  ListTopicSectionVideoCall,
  ListVideoLessonCall,
} from "../Slices/VideoUpload/ApiVideoupload";
import {
  AddDiscussionVideoLessonsCall,
  AddNoteVideoLessonsCall,
  AskAIVideoLessonsCall,
  CourseDetailsVideoLessonsCall,
  DeleteDiscussionVideoLessonsCall,
  DeleteNoteVideoLessonsCall,
  EditDiscussionVideoLessonsCall,
  EditNoteVideoLessonsCall,
  FavAndWatchLaterVideoLessonsCall,
  LikeDiscussionVideoLessonsCall,
  ListDiscussionVideoLessonsCall,
  ListGetVideoLessonsCall,
  ListNoteVideoLessonsCall,
  ListUserVideoLessonCall,
  ListUserVideoLessonListsCall,
  ListUserVideoLessonSubjectfromTopicCall,
  ListVideoLessonAnalyticsCall,
  ProgressUpdateVideoLessonsCall,
} from "../Slices/UserVideoLessons/ApiUserVideoLesson";
import { ChatpracticeEvaluationCall } from "../Slices/ChatbotpracticeEvaluation/ChatpracticeEvaluationApi";
import { ChatbotExamEvaluationCall } from "../Slices/ChatbotExamEvaluation/ChatbotExamEvaluationApi";
import {
  AdminreprintCall,
  AiDriveSearchCall,
  BookletMaterialCreate_UpdateCall,
  BookletMaterialReadCall,
  BookletRequestDecisionCall,
  BookletRequestDecisionReadCall,
  BookletRequestReadCall,
  CentreMaster_DeleteCall,
  CentreMaster_Update_ApiCall,
  CentreMasterCreate_Call,
  CentreMasterLocationCall,
  CentreMasterMappingCreate_Update_DeleteCall,
  CentreMasterMappingReadCall,
  CentreMasterReadCall,
  ClassCentereCall,
  ClassDrive_fileCall,
  ClassSelectionMasterCreate_Update_DeleteCall,
  ClassSelectionMasterReadCall,
  ClassSelectionSubjectRaedCall,
  ClassSlectionDataCall,
  ClassSubjectCall,
  ClassyeargroupCall,
  CommonFilterApiCall,
  DashboardPrintListCall,
  DefaultPrinterOptions_Update_ApiCall,
  DefaultPrinterOptionsCall,
  LessonPlanReadCall,
  MyRequestReadCall,
  PreviousClassReadCall,
  PreviousSelection_CRUDApiCall,
  PrinterChangeCall,
  PrinterListCall,
  PrinterMasterCreate_Update_DeleteCall,
  PrinterMasterReadCall,
  PrinterOptionsCall,
  ReprintCall,
  RoleReadCall,
  StudyMaterialAddToCartCall,
  StudyMaterialCartCountCall,
  StudyMaterialCartReadCall,
  StudyMaterialPreviewCall,
  StudyMaterialReadByIdCall,
  StudyMaterialReadCall,
  StudyMaterialRequestCreateCall,
  Subject_Drive_MapMasterCreate_Update_DeleteCall,
  Subject_Drive_MapMasterReadCall,
  SubjectFolderMasterRaedCall,
  TutorAdminDashboardCalenderCall,
  TutorAdminDashboardCall,
  TutorAdminReportCall,
  TutorAdminReportFilterCall,
  TutorAdminReportReprintCall,
  TutorDashboardCalenderCall,
  TutorDashboardClassesCall,
  TutorDashboardStatusCall,
  TutorDashboardSummmaryCall,
  TutorMasterCreate_Update_DeleteCall,
  TutorReportCall,
  TutorReportFilterCall,
  TutorsMasterReadCall,
} from "../Slices/Booklet/SagaApiCall";
import { StudyMaterialPreview } from "../Slices/Booklet/Tutor/StudyMaterial/StudyMaterialPreview";
import { CentreMasterLocation } from "../Slices/Booklet/Admin/CentreMaster/CentreMatserLocation";
import {
  ListPoicyCall,
  ListPrivacyPoicyCall,
  ListTerms_and_Conditon_Call,
  Policy_Create_UpdateCall,
} from "../Slices/PrivacyPolicy/ApiPolicyterms";
import { ChatbotWithElliotCall } from "../Slices/ChatwithElliot/ChatwithElliotApi";
import {
  ActiveUserFilterCall,
  GateAdminDashboardApiCall,
  OverallActivityFilterCall,
  TestCompletedFilterCall,
} from "../Slices/GateAdminDashboard/ApiAdminDashboard";
import { LeadDataCall, Session_CrudCall, SessionReadCall } from "../Slices/CRM/CRM_api_call";
import { getAddRolesScreenApiCall, getRoleMappingApiCall } from "../Slices/RoleMapping/RoleMappingApi";
import { RoleScreenYGPermissionSaga, ManageRoleScreenYGPermissionSaga } from "../Slices/RoleScreenYGPermission/RoleScreenYGPermissionApi";
import { ListVideoTutorialsCall, AddVideoTutorialCall, EditVideoTutorialCall, DeleteVideoTutorialCall } from "../Slices/VideoTutorials/ApiVideoTutorials";
import { ListVideoTutorialCategoryCall, AddVideoTutorialCategoryCall, EditVideoTutorialCategoryCall, DeleteVideoTutorialCategoryCall } from "../Slices/VideoTutorialCategory/ApiVideoTutorialCategory";

export default function* rootSage() {
  yield takeLatest("Test/testCall", TestCall);
  // yield takeLatest("pattern",worker)

  // Dashboard
  yield takeLatest("DashboardCard/dashboardCard", DashboardCardCall);
  yield takeLatest("DashboardChart/dashboardChart", DashboardChartCall);

  // DashboardData
  yield takeLatest(
    "DashboardDataCard/dashboardDataCard",
    DashboardDataCardCall
  );

  //  Day calculation
  yield takeLatest(
    "ListdaycalculationSlice/listdaycalculation",
    ListdaycalculationCall
  );

  // User Permission
  yield takeLatest(
    "EditUserPermission/editUserPermission",
    EditUserPermissionCall
  );
  yield takeLatest(
    "UserPermissionRows/userPermissionRowsList",
    ListUserPermissionRowsCall
  );
  // SideMenu Permission
  yield takeLatest(
    "SideMenuPermission/listSideMenuPermission",
    SideMenuPermissionCall
  );

  // Role
  yield takeLatest("ListRoleSlice/listRole", ListRoleCall);
  yield takeEvery("AddRoleSlice/addRole", AddRoleCall);
  yield takeEvery("EditRoleSlice/EditRole", EditRoleCall);
  yield takeEvery("DeleteRole/deleteRole", DeleteRoleCall);
  // Role Screen YG Permission
  yield takeLatest("ListRoleScreenYGPermission/getListRoleScreenYGPermission", RoleScreenYGPermissionSaga);
  yield takeLatest("ManageRoleScreenYGPermission/manageRoleScreenYGPermission", ManageRoleScreenYGPermissionSaga);

  // Study
  yield takeLatest(
    "ListSubjectNoteSlice/listSubjectNote",
    ListStudyNoteSubjectSliceCall
  );
  yield takeLatest(
    "ListSubjectNoteSubTopicSlice/listListSubjectNoteSubTopicSlice",
    ListStudyNoteSubjectTopicSubSliceCall
  );
  yield takeLatest(
    "ListSubjectNoteTopicSlice/listListSubjectNoteTopicSlice",
    ListStudyNoteSubjectTopicSliceCall
  );
  yield takeLatest(
    "ListSubjectNoteContentSlice/listListSubjectNoteContentSlice",
    ListStudyContentSliceCall
  );

  // Registration
  yield takeLatest("RegistrationSlicer/registrationStart", RegistrationCall);
  yield takeLatest(
    "ListRegistrationYeargroupSlice/listRegistrationYeargroup",
    ListRegistrationYeargroupCall
  );

  // Login
  yield takeLatest("GoogleLoginSlicer/GoogleloginStart", GoogleLoginCall);
  yield takeLatest("LoginSlicer/loginStart", LoginCall);
  yield takeLatest("ForgotPassword/ForgotPasswordStart", ForgotPasswordCall);
  // Reset Password
  yield takeLatest("ResetPassword/resetPasswordStart", ResetPasswordCall);

  // Menu
  yield takeLatest("ListMenuSlice/listMenu", ListMenuCall);
  yield takeEvery("AddMenuSlice/addMenu", AddMenuCall);
  yield takeEvery("EditMenuSlice/EditMenu", EditMenuCall);
  yield takeEvery("DeleteMenu/deleteMenu", DeleteMenuCall);

  // Screen
  yield takeLatest("ScreenList/getScreenList", getScreenListApiCall);
  yield takeLatest("RolesScreenlist/getRolesScreenlist", getRolesScreenlistApiCall);

  // Role Mapping Master
  yield takeLatest("RoleMapping/getRoleMapping", getRoleMappingApiCall);
  yield takeLatest("AddRolesScreen/getAddRolesScreen", getAddRolesScreenApiCall);

  // QuestionSubType
  yield takeLatest(
    "ListQuestionSubTypeSlice/listQuestionSubType",
    ListQuestionSubTypeCall
  );
  yield takeLatest(
    "QuestionSubTypelistSlice/QuestionSubTypelist",
    QuestionSubTypelistCall
  );
  yield takeEvery(
    "AddQuestionSubTypeSlice/addQuestionSubType",
    AddQuestionSubTypeCall
  );
  yield takeEvery(
    "EditQuestionSubTypeSlice/EditQuestionSubType",
    EditQuestionSubTypeCall
  );
  yield takeEvery(
    "DeleteQuestionSubType/deleteQuestionSubType",
    DeleteQuestionSubTypeCall
  );

  // QuestionType
  yield takeLatest(
    "ListQuestionTypeSlice/listQuestionType",
    ListQuestionTypeCall
  );
  yield takeEvery("AddQuestionTypeSlice/addQuestionType", AddQuestionTypeCall);
  yield takeEvery(
    "EditQuestionTypeSlice/EditQuestionType",
    EditQuestionTypeCall
  );
  yield takeEvery(
    "DeleteQuestionType/deleteQuestionType",
    DeleteQuestionTypeCall
  );

  yield takeEvery(
    "ScheduleQuestionTypesSlice/scheduleQuestionTypes",
    ScheduleQuestionTypesCall
  );

  yield takeEvery(
    "ListDashboardPerformenceTrendSlice/listDashboardPerformenceTrend",
    ListDashboardPerformenceTrendCall
  );
  // flag
  yield takeLatest("ListFlagSlice/listFlag", ListFlagCall);
  yield takeLatest("ListFlagExamSlice/listFlagExam", ListFlagExamCall);
  yield takeLatest("ListFlagExamSlice/listFlagExam", ListFlagExamCall);
  yield takeLatest(
    "ListFlagExamSubmissionSlice/listFlagExamSubmission",
    ListFlagExamSubmissionCall
  );

  // QuestionType
  yield takeLatest("ListyearGroupSlice/listyearGroup", ListyearGroupCall);
  yield takeEvery("AddyearGroupSlice/addyearGroup", AddyearGroupCall);
  yield takeEvery("EdityearGroupSlice/EdityearGroup", EdityearGroupCall);
  yield takeEvery("DeleteyearGroup/deleteyearGroup", DeleteyearGroupCall);

  // newDashord
  yield takeLatest(
    "ListRecentActivitySlice/listRecentActivity",
    ListRecentActivityCall
  );
  yield takeLatest(
    "ListQuestionBankSlice/listQuestionBank",
    ListQuestionBankCall
  );
  yield takeLatest(
    "ListPrefmanceTrendSlice/listPrefmanceTrend",
    ListPrefmanceTrendCall
  );
  yield takeLatest("ListPerformanceSlice/listPerformance", ListPerformanceCall);
  yield takeLatest(
    "ListDashboardprogressSlice/listDashboardprogress",
    ListDashboardprogressCall
  );
  yield takeLatest("ListDailygoalsSlice/listDailygoals", ListDailygoalsCall);
  yield takeEvery("AddCreategoalsSlice/addCreategoals", AddCreategoalsCall);

  // ExamHistory
  yield takeLatest(
    "ListMockExamHistorySlice/listMockExamHistory",
    ListMockExamHistoryCall
  );
  yield takeLatest(
    "ListExamHistoryReWritingSlice/listExamHistoryReWritingSlice",
    ListExamHistoryReWritingSliceCall
  );
  yield takeLatest("ListExamHistorySlice/listExamHistory", ListExamHistoryCall);
  yield takeEvery("AddExamHistorySlice/addExamHistory", AddExamHistoryCall);
  yield takeEvery("EditExamHistorySlice/EditExamHistory", EditExamHistoryCall);
  yield takeEvery("DeleteExamHistory/deleteExamHistory", DeleteExamHistoryCall);
  // Questions
  yield takeLatest("ListQuestionsSlice/listQuestions", ListQuestionsCall);
  yield takeLatest("QuestionMappingSlice/listQuestionMapping", QuestionMappingCall);
  yield takeEvery("AddQuestionsSlice/addQuestions", AddQuestionsCall);
  yield takeEvery("EditQuestionsSlice/EditQuestions", EditQuestionsCall);
  yield takeEvery("DeleteQuestions/deleteQuestions", DeleteQuestionsCall);
  yield takeEvery("BulkUploadQuestionsSlice/bulkUploadQuestions", BulkUploadQuestionsCall);

  yield takeEvery("AddFalgSlice/addFalg", AddFalgCall);
  yield takeEvery("AddFalgExamSlice/addFalgExam", AddFalgExamCall);

  // Examdate
  yield takeLatest("ListExamdateSlice/listExamdate", ListExamdateCall);
  yield takeEvery("AddExamdateSlice/addExamdate", AddExamdateCall);
  yield takeEvery("EditExamdateSlice/EditExamdate", EditExamdateCall);
  yield takeEvery("DeleteExamdate/deleteExamdate", DeleteExamdateCall);

  // Options
  yield takeLatest("ListOptionsSlice/listOptions", ListOptionsCall);
  yield takeEvery("AddOptionsSlice/addOptions", AddOptionsCall);
  yield takeEvery("EditOptionsSlice/EditOptions", EditOptionsCall);
  yield takeEvery("DeleteOptions/deleteOptions", DeleteOptionsCall);

  // ExamModel
  yield takeLatest("ListExamModelSlice/listExamModel", ListExamModelCall);
  yield takeEvery("AddExamModelSlice/addExamModel", AddExamModelCall);
  yield takeEvery("EditExamModelSlice/EditExamModel", EditExamModelCall);
  yield takeEvery("DeleteExamModel/deleteExamModel", DeleteExamModelCall);

  // Exam
  yield takeLatest("ListEvaluationSlice/listEvaluation", ListEvaluationCall);
  yield takeLatest("ListExamsubmitSlice/listExamsubmit", ListExamsubmitCall);
  yield takeLatest("ListExamIDSlice/listExamID", ListExamIDCall);
  yield takeLatest(
    "ListInstructionExamSlice/listInstructionExamID",
    ListInstructionExamIDCall
  );

  yield takeLatest(
    "ListReExamPracticeIDSlice/listReExamPracticeID",
    ListReExamPracticeIDCall
  );

  yield takeLatest("ListReExamIDSlice/listReExamID", ListReExamIDCall);
  yield takeLatest("PendingExamSlice/pendingExam", PendingExamCall);
  yield takeLatest(
    "ListReViewExamIDSlice/listReViewExamID",
    ListReViewExamIDCall
  );
  yield takeLatest("ListExamSlice/listExam", ListExamCall);
  yield takeEvery("AddExamSlice/addExam", AddExamCall);
  yield takeEvery("AddCloseSectionSlice/addCloseSection", AddCloseSectionCall);
  yield takeEvery("EditExamSlice/EditExam", EditExamCall);
  yield takeEvery("DeleteExam/deleteExam", DeleteExamCall);
  yield takeEvery("AddOpenSectionSlice/addOpenSection", AddOpenSectionCall);
  yield takeLatest(
    "ListExamsubmitoverallSlice/listExamsubmitoverall",
    ListExamsubmitoverallCall
  );
  // Practice Exam
  yield takeLatest(
    "ListReViewExamIDPracticeSlice/listReViewExamIDPractice",
    ListReViewExamIDPracticeCall
  );
  yield takeLatest(
    "ListEvaluationPracticeSlice/listEvaluationPractice",
    ListEvaluationPracticeCall
  );
  yield takeLatest(
    "ListEvaluationPracticewritingExamSlice/listEvaluationPracticewritingExam",
    ListEvaluationPracticewritingExamCall
  );
  yield takeLatest(
    "ListExamsubmitPracticeSlice/listExamsubmitPractice",
    ListExamsubmitPracticeCall
  );
  yield takeLatest(
    "PendingPracticeExamSlice/pendingPracticeExam",
    PendingPracticeExamCall
  );
  yield takeLatest(
    "ListPracticeExamIDSlice/listPracticeExamID",
    ListPracticeExamIDCall
  );
  yield takeLatest(
    "ListInstructionPracticeExamSlice/listInstructionPracticeExamID",
    ListInstructionPracticeExamIDCall
  );
  yield takeLatest(
    "ListPracticeExamSlice/listPracticeExam",
    ListPracticeExamCall
  );
  yield takeEvery("AddPracticeExamSlice/addPracticeExam", AddPracticeExamCall);
  yield takeEvery(
    "EditPracticeExamSlice/EditPracticeExam",
    EditPracticeExamCall
  );
  yield takeEvery(
    "DeletePracticeExam/deletePracticeExam",
    DeletePracticeExamCall
  );

  //  Practice test Exam
  yield takeLatest(
    "ListPracticeTestSlice/listPracticeTest",
    ListPracticeTestCall
  );

  // Student Exam
  yield takeLatest("ListStudentExamSlice/listStudentExam", ListStudentExamCall);
  yield takeEvery("AddStudentExamSlice/addStudentExam", AddStudentExamCall);
  yield takeEvery("EditStudentExamSlice/EditStudentExam", EditStudentExamCall);

  // StudentPractice Exam
  yield takeLatest(
    "ListStudentExamPracticeSlice/listStudentExamPractice",
    ListStudentExamPracticeCall
  );
  yield takeEvery(
    "AddStudentExamPracticeSlice/addStudentExamPractice",
    AddStudentExamPracticeCall
  );
  yield takeEvery(
    "EditStudentExamPracticeSlice/EditStudentExamPractice",
    EditStudentExamPracticeCall
  );

  // ExamAnswer Practice
  yield takeLatest(
    "ListExamAnswerPracticeSlice/listExamAnswerPractice",
    ListExamAnswerPracticeCall
  );
  yield takeEvery(
    "AddExamAnswerPracticeSlice/addExamAnswerPractice",
    AddExamAnswerPracticeCall
  );

  // ExamAnswer
  yield takeLatest("ListExamAnswerSlice/listExamAnswer", ListExamAnswerCall);
  yield takeEvery("AddExamAnswerSlice/addExamAnswer", AddExamAnswerCall);
  yield takeEvery("EditExamAnswerSlice/EditExamAnswer", EditExamAnswerCall);
  yield takeEvery("DeleteExamAnswer/deleteExamAnswer", DeleteExamAnswerCall);

  // Instruction
  yield takeLatest("ListInstructionSlice/listInstruction", ListInstructionCall);
  yield takeEvery("AddInstructionSlice/addInstruction", AddInstructionCall);
  yield takeEvery("EditInstructionSlice/EditInstruction", EditInstructionCall);
  yield takeEvery("DeleteInstruction/deleteInstruction", DeleteInstructionCall);

  // FeedBack
  yield takeLatest("ListFeedBackSlice/listFeedBack", ListFeedBackCall);
  yield takeEvery("AddFeedBackSlice/addFeedBack", AddFeedBackCall);
  yield takeEvery("EditFeedBackSlice/EditFeedBack", EditFeedBackCall);
  yield takeEvery("DeleteFeedBack/deleteFeedBack", DeleteFeedBackCall);
  yield takeEvery(
    "AddFeedBackPracticeSlice/addFeedBackPractice",
    AddFeedBackPracticeCall
  );

  //terms & policy
  yield takeLatest("PolicyMasterReadSlice/PolicyMasterRead", ListPoicyCall);
  yield takeLatest(
    "PolicyCreate_UpdateSlice/PolicyCreate_Update",
    Policy_Create_UpdateCall
  );
  yield takeLatest(
    "Privacy_PolicyReadSlice/Privacy_PolicyRead",
    ListPrivacyPoicyCall
  );
  yield takeLatest(
    "Terms_and_ConditionReadSlice/Terms_and_ConditionRead",
    ListTerms_and_Conditon_Call
  );

  // Package
  yield takeLatest("ListPackageSlice/listPackage", ListPackageCall);
  yield takeEvery("AddPackageSlice/addPackage", AddPackageCall);
  yield takeEvery("EditPackageSlice/EditPackage", EditPackageCall);
  yield takeEvery("DeletePackage/deletePackage", DeletePackageCall);
  yield takeLatest(
    "ListPackageDomainSlice/listPackageDomain",
    ListPackageDomainCall
  );
  yield takeLatest(
    "ListPackagePeriodSlice/listPackagePeriod",
    ListPackagePeriodCall
  );
  yield takeLatest(
    "ListSubscribedUserSlice/listSubscribedUser",
    ListSubscribedUserCall
  );
  // Courses
  yield takeLatest("ListCoursesSlice/listCourses", ListCoursesCall);
  yield takeEvery("AddCoursesSlice/addCourses", AddCoursesCall);
  yield takeEvery("EditCoursesSlice/EditCourses", EditCoursesCall);
  yield takeEvery("DeleteCourses/deleteCourses", DeleteCoursesCall);

  // User Admin
  yield takeLatest("ListUserAdminSlice/listUserAdmin", ListUserAdminCall);
  yield takeEvery("AddUserAdminSlice/addUserAdmin", AddUserAdminCall);
  yield takeEvery("EditUserAdminSlice/EditUserAdmin", EditUserAdminCall);
  yield takeEvery("DeleteUserAdmin/deleteUserAdmin", DeleteUserAdminCall);

  //  support
  yield takeEvery("AddSupportSlice/addSupport", AddSupportCall);
  yield takeLatest("ListFAQSlice/listFAQ", ListFAQCall);
  //  setting
  yield takeEvery("AddSettingSlice/addSetting", AddSettingCall);
  yield takeLatest(
    "ListSettingResetSlice/listSettingReset",
    ListSettingResetCall
  );
  yield takeLatest(
    "ListSettingResetMockSlice/listSettingResetMock",
    ListSettingResetMockApiCall
  );
  // Country
  yield takeLatest("ListCountrySlice/listCountry", ListCountryCall);
  yield takeEvery("AddCountrySlice/addCountry", AddCountryCall);
  yield takeEvery("EditCountrySlice/EditCountry", EditCountryCall);
  yield takeEvery("DeleteCountry/deleteCountry", DeleteCountryCall);

  // User
  yield takeLatest("ListUserSlice/listUser", ListUserCall);
  yield takeEvery("AddUserSlice/addUser", AddUserCall);
  yield takeEvery("EditUserSlice/EditUser", EditUserCall);
  yield takeEvery("DeleteUser/deleteUser", DeleteUserCall);
  //  list user
  yield takeLatest("ListYearGroupSlice/listYearGroup", ListYearGroupCall);
  yield takeLatest("ListRegionSlice/listRegion", ListRegionCall);

  //  user package
  yield takeLatest("ListUserPackageSlice/listUserPackage", ListUserPackageCall);
  yield takeLatest(
    "ListUserPackageDetailsSlice/listUserPackageDetails",
    ListUserPackageDetailsCall
  );
  yield takeLatest(
    "ListUserExamListSlice/listUserExamList",
    ListUserExamListCall
  );
  yield takeLatest("PendingExamList/pendingExamList", PendingExamListApiCall);

  //  chatbot
  yield takeEvery("ChatbotPublicSlicer/chatbotPublic", ChatbotPublicCall);
  yield takeEvery(
    "WritingChatbotPublicSlicer/WritingchatbotPublic",
    WritingChatbotPublicCall
  );
  yield takeEvery(
    "ReadChatbotPublicSlicer/ReadchatbotPublic",
    ReadChatbotPublicCall
  );
  yield takeEvery(
    "ExamWritingChatbotPublicSlicer/ExamWritingchatbotPublic",
    ExamWritingChatbotPublicCall
  );
  yield takeEvery(
    "ExamReadChatbotPublicSlicer/ExamReadchatbotPublic",
    ExamReadChatbotPublicCall
  );
  yield takeEvery("ChatbotSlicer/chatbotStart", ChatbotCall);
  yield takeEvery("ChatWithElliotSlicer/ChatWithElliot", ChatbotWithElliotCall);
  yield takeEvery(
    "ChatpracticeEvaluationSlicer/ChatpracticeEvaluation",
    ChatpracticeEvaluationCall
  );
  yield takeEvery(
    "ChatbotExamEvaluationSlicer/ChatbotExamEvaluation",
    ChatbotExamEvaluationCall
  );

  // Mock Exam
  yield takeLatest("MockExamSlice/listMockExam", ListMockExamCall);

  // Reading prompt
  yield takeLatest(
    "ReadingPromptSlice/listReadingPrompt",
    ListReadingPromptCall
  );

  // Writing exam
  yield takeLatest(
    "ListWritingExamAISlice/listListWritingExamAISlice",
    ListWritingExamAISliceCall
  );
  yield takeLatest(
    "ListWritingExamPracticeSlice/listListWritingExamPracticeSlice",
    ListWritingExamPracticeSliceCall
  );
  yield takeLatest(
    "ListWritingExamAIPracticeSlice/listListWritingExamAIPracticeSlice",
    ListWritingExamAIPracticeSliceCall
  );
  //  Skill
  yield takeEvery(
    "AddArithmeticGameSkillSlice/addArithmeticGameSkill",
    AddArithmeticGameSkillCall
  );
  yield takeEvery(
    "AddMemoryGameSkillSlice/addMemoryGameSkill",
    AddMemoryGameSkillCall
  );
  // exter api
  yield takeLatest("ListCountryListSlice/listCountryList", ListCountryListCall);
  yield takeLatest("ListStateSlice/listState", ListStateCall);

  // Yearlevel_map
  yield takeLatest(
    "ListYearlevel_mapSlice/listYearlevel_map",
    ListYearlevel_mapCall
  );
  yield takeEvery(
    "AddYearlevel_mapSlice/addYearlevel_map",
    AddYearlevel_mapCall
  );
  yield takeEvery(
    "EditYearlevel_mapSlice/EditYearlevel_map",
    EditYearlevel_mapCall
  );
  yield takeEvery(
    "DeleteYearlevel_map/deleteYearlevel_map",
    DeleteYearlevel_mapCall
  );

  // ContentMobile
  yield takeLatest(
    "ListContentMobileSlice/listContentMobile",
    ListContentMobileCall
  );
  yield takeEvery(
    "AddContentMobileSlice/addContentMobile",
    AddContentMobileCall
  );
  yield takeEvery(
    "EditContentMobileSlice/EditContentMobile",
    EditContentMobileCall
  );
  yield takeEvery(
    "DeleteContentMobile/deleteContentMobile",
    DeleteContentMobileCall
  );

  // SubtopicMobile
  yield takeLatest(
    "ListSubtopicMobileSlice/listSubtopicMobile",
    ListSubtopicMobileCall
  );
  yield takeEvery(
    "AddSubtopicMobileSlice/addSubtopicMobile",
    AddSubtopicMobileCall
  );
  yield takeEvery(
    "EditSubtopicMobileSlice/EditSubtopicMobile",
    EditSubtopicMobileCall
  );
  yield takeEvery(
    "DeleteSubtopicMobile/deleteSubtopicMobile",
    DeleteSubtopicMobileCall
  );

  // SubjectMobile
  yield takeLatest(
    "ListSubjectMobileSlice/listSubjectMobile",
    ListSubjectMobileCall
  );
  yield takeEvery(
    "AddSubjectMobileSlice/addSubjectMobile",
    AddSubjectMobileCall
  );
  yield takeEvery(
    "EditSubjectMobileSlice/EditSubjectMobile",
    EditSubjectMobileCall
  );
  yield takeEvery(
    "DeleteSubjectMobile/deleteSubjectMobile",
    DeleteSubjectMobileCall
  );
  // subscription
  yield takeLatest(
    "ListSubscriptionSlice/listSubscription",
    ListSubscriptionCall
  );
  yield takeEvery("AddSubscriptionSlice/AddSubscription", AddSubscriptionCall);
  yield takeEvery(
    "DeleteSubscription/deleteSubscription",
    DeleteSubscriptionCall
  );

  // billing
  yield takeLatest("ListBillingSlice/listBilling", ListBillingCall);
  // SubscriptionMap
  yield takeLatest(
    "ListSubscribedMapSlice/listSubscribedMap",
    ListSubscribedMapCall
  );
  yield takeEvery(
    "AddSubscribedMapSlice/addSubscribedMap",
    AddSubscribedMapCall
  );
  yield takeEvery(
    "EditSubscribedMapSlice/EditSubscribedMap",
    EditSubscribedMapCall
  );
  yield takeEvery(
    "DeleteSubscribedMap/deleteSubscribedMap",
    DeleteSubscribedMapCall
  );

  yield takeEvery("AddVideoUploadSlice/addVideoUpload", AddVideoLessonCall); // added by Manikandan

  yield takeEvery("EditVideoUploadSlice/editVideoUpload", EditVideoLessonCall); // added by Manikandan

  yield takeEvery(
    "DeleteVideoUploadSlice/deleteVideoUpload",
    DeleteVideoLessonCall
  ); // added by Manikandan

  yield takeEvery("ListVideoUploadSlice/listVideoUpload", ListVideoLessonCall); // added by Manikandan

  yield takeEvery(
    "ListTopicSectionVideoSlice/listTopicSectionVideo",
    ListTopicSectionVideoCall
  );
  // added by Manikandan
  yield takeEvery(
    "ListVideoSubjectSlice/listVideoSubject",
    ListUserVideoLessonCall
  ); // added by Manikandan
  yield takeEvery(
    "ListVideoTopicSlice/listVideoTopic",
    ListUserVideoLessonSubjectfromTopicCall
  ); // added by Manikandan
  yield takeEvery(
    "ListVideoLessonsListSlice/listVideoLessonsLists",
    ListUserVideoLessonListsCall
  ); // added by Manikandan
  yield takeEvery(
    "AddNoteVideoLessonsSlice/AddNoteVideoLesson",
    AddNoteVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "ListNoteVideoLessonsSlice/ListNoteVideoLesson",
    ListNoteVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "ListGetVideoLessonsSlice/ListGetVideoLesson",
    ListGetVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "EditNoteVideoLessonsSlice/EditNoteVideoLesson",
    EditNoteVideoLessonsCall
  ); // added by Manikandan

  yield takeEvery(
    "DeleteNoteVideoLessonsSlice/DeleteNoteVideoLesson",
    DeleteNoteVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "AskAIVideoLessonsSlice/AskAIVideoLesson",
    AskAIVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "ListDiscussionVideoLessonsSlice/ListDiscussionVideoLesson",
    ListDiscussionVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "AddDiscussionVideoLessonsSlice/AddDiscussionVideoLesson",
    AddDiscussionVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "EditDiscussionVideoLessonsSlice/EditDiscussionVideoLessons",
    EditDiscussionVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "DeleteDiscussionVideoLessonsSlice/DeleteDiscussionVideoLessons",
    DeleteDiscussionVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "LikeDiscussionVideoLessonsSlice/LikeDiscussionVideoLesson",
    LikeDiscussionVideoLessonsCall
  ); // added by Manikandan

  yield takeEvery(
    "FavAndWatchLaterVideoLessonsSlice/FavAndWatchLaterVideoLesson",
    FavAndWatchLaterVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "CourseDetailsVideoLessonsSlice/CourseDetailsVideoLesson",
    CourseDetailsVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "DashboardCalenderDataSlice/dashboardCalenderData",
    DashboardCalenderDataCall
  ); // added by Manikandan
  yield takeLatest(
    "DashboardweeklyprefSlice/dashboardweeklypref",
    DashboardweeklyprefCall
  ); // added by Aiswarya

  yield takeLatest("AchievementsSlice/ListAchievements", AchievementsCall);

  yield takeLatest(
    "Recommended_ActionSlice/ListRecommended_Action",
    Recommended_ActionCall
  );

  yield takeEvery(
    "ProgressUpdateVideoLessonsSlice/ProgressUpdateVideoLesson",
    ProgressUpdateVideoLessonsCall
  ); // added by Manikandan
  yield takeEvery(
    "GetQuestionSubTypeSlice/GetQuestionSubType",
    GetQuestionSubTypeCall
  ); // added by Manikandan

  yield takeEvery("ListSubjectListSlice/ListSubjectList", ListSubjectListCall); // added by Manikandan

  // writing ai chatbox
  yield takeLatest(
    "WritingChatbotSlicer/writingchatbotStart",
    WritingChatbotCall
  );

  yield takeLatest(
    "VideoLessonAnalyticsSlice/VideoLessonAnalytics",
    ListVideoLessonAnalyticsCall
  );

  //#region Booklet

  //#region AdminModule

  // Read Booklet Material
  yield takeLatest(
    "BookletMaterialReadSlice/bookletMaterialRead",
    BookletMaterialReadCall
  );

  // Create Update an Delete Booklet Material
  yield takeLatest(
    "BookletMaterialCreateSlice/bookletMaterialCreate",
    BookletMaterialCreate_UpdateCall
  );

  // Read Booklet Request
  yield takeLatest(
    "BookletRequestReadSlice/bookletRequestRead",
    BookletRequestReadCall
  );

  //  Read Decision Booklet Request
  yield takeLatest(
    "BookletRequestDecisionReadSlice/bookletRequestDecisionRead",
    BookletRequestDecisionReadCall
  );

  // Decision Booklet Request
  yield takeLatest(
    "BookletRequestDecisionSlice/bookletRequestDecision",
    BookletRequestDecisionCall
  );

  yield takeLatest("PrinterOptionsSlice/PrinterOptions", PrinterOptionsCall);

  yield takeLatest(
    "DefaultPrinterSlice/DefaultPrinter",
    DefaultPrinterOptionsCall
  );

  yield takeLatest("PrinterListSlice/PrinterList", PrinterListCall);
  yield takeLatest("PrinterChangeSlice/PrinterChange", PrinterChangeCall);
  // Read Centre Master
  yield takeLatest(
    "CentreMasterReadSlice/centreMasterRead",
    CentreMasterReadCall
  );
  yield takeLatest(
    "CentreMasterLocationSlice/CentreMasterLocation",
    CentreMasterLocationCall
  );

  // Create, Update, Delete Centre Master
  yield takeLatest(
    "CentreMasterCreateSlice/centreMasterCreate",
    CentreMasterCreate_Call
  );

  yield takeLatest(
    "CentreMasterUpdateSlice/centreMasterUpdate",
    CentreMaster_Update_ApiCall
  );
  yield takeLatest(
    "CentreMasterDeleteSlice/centreMasterDelete",
    CentreMaster_DeleteCall
  );

  //Read Centre Master Mapping
  yield takeLatest(
    "CentreMasterMappingReadSlice/centreMasterMappingRead",
    CentreMasterMappingReadCall
  );

  // Create, Update, Delete Centre Master Mapping
  yield takeLatest(
    "CentreMasterMappingCreateSlice/centreMasterMappingCreate",
    CentreMasterMappingCreate_Update_DeleteCall
  );

  //Read Printer Master
  yield takeLatest(
    "PrinterMasterReadSlice/printerMasterRead",
    PrinterMasterReadCall
  );

  // Create, Update, Delete Printer Master
  yield takeLatest(
    "PrinterCreate_UpdateSlice/printerCreate_Update",
    PrinterMasterCreate_Update_DeleteCall
  );
  yield takeLatest(
    "DefaultPrinterUpdateSlice/DefaultPrinterUpdate",
    DefaultPrinterOptions_Update_ApiCall
  );

  //Read Tutors Master
  yield takeLatest("RolesReadSlice/RolesRead", RoleReadCall);
  yield takeLatest("TutorsReadSlice/tutorsRead", TutorsMasterReadCall);
  yield takeLatest(
    "TutorCreate_UpdateSlice/TutorCreate_Update",
    TutorMasterCreate_Update_DeleteCall
  );

  //#endregion AdminModule

  //#region Common Filter
  // Filter For Admin and Tutor Module
  yield takeLatest("CommonFilterSlice/commonFilter", CommonFilterApiCall);
  //#endregion Common Filter

  //#region Tutor Modile

  // Read Study Material
  yield takeLatest(
    "StudyMaterialReadSlice/studyMaterialRead",
    StudyMaterialReadCall
  );

  yield takeLatest(
    "StudyMaterialPreviewSlice/StudyMaterialPreview",
    StudyMaterialPreviewCall
  );
  yield takeLatest(
    "StudyMaterialReadByIdSlice/StudyMaterialReadById",
    StudyMaterialReadByIdCall
  );

  yield takeLatest(
    "StudyMaterialCartReadSlice/StudyMaterialCartRead",
    StudyMaterialCartReadCall
  );

  yield takeLatest(
    "StudyMaterialCartCountSlice/StudyMaterialCartCount",
    StudyMaterialCartCountCall
  );
  // Add To Cart Study Material
  yield takeLatest(
    "StudyMaterialAddToCartCreateSlice/studyMaterialAddToCartCreate",
    StudyMaterialAddToCartCall
  );

  // Request Create Study Material
  yield takeLatest(
    "StudyMaterialRequestCreateSlice/studyMaterialRequestCreate",
    StudyMaterialRequestCreateCall
  );

  //Read Lesson Plan
  yield takeLatest("LessonPlanReadSlice/LessonPlanRead", LessonPlanReadCall);

  // Read My Request
  yield takeLatest("MyRequestReadSlice/myRequestRead", MyRequestReadCall);

  //#endregion Tutor Modile

  //subject_drive_Map
  yield takeLatest(
    "Subject_Drive_MapMasterReadSlice/Subject_Drive_MapMasterRead",
    Subject_Drive_MapMasterReadCall
  );
  yield takeLatest(
    "Subject_Drive_MapCreate_UpdateSlice/Subject_Drive_MapCreate_Update",
    Subject_Drive_MapMasterCreate_Update_DeleteCall
  );
  yield takeLatest(
    "SubjectFolderMasterReadSlice/SubjectFolderMasterRead",
    SubjectFolderMasterRaedCall
  );

  //Class selection master
  yield takeLatest(
    "ClassSelectionMasterReadSlice/ClassSelectionMasterRead",
    ClassSelectionMasterReadCall
  );
  yield takeLatest(
    "ClassSelectionCreate_UpdateSlice/ClassSelectionCreate_Update",
    ClassSelectionMasterCreate_Update_DeleteCall
  );
  yield takeLatest(
    "ClassSelectionSubjectReadSlice/ClassSelectionSubjectRead",
    ClassSelectionSubjectRaedCall
  );

  // booklet Dashboard class Selection

  yield takeLatest(
    "ClassYeargroupReadSlice/ClassYeargroupRead",
    ClassyeargroupCall
  );
  yield takeLatest(
    "ClassCenterReadSlice/ClassCenterRead",
    ClassCentereCall
  );

  yield takeLatest("ClassSubjectReadSlice/ClassSubjectRead", ClassSubjectCall);

  yield takeLatest(
    "ClassDrive_fileReadSlice/ClassDrive_fileRead",
    ClassDrive_fileCall
  );


  yield takeLatest(
    "PreviousClassReadSlice/PreviousClassRead",
    PreviousClassReadCall
  );

  yield takeLatest(
    "PreviousClass_CRUDReadSlice/PreviousClass_CRUDRead",
    PreviousSelection_CRUDApiCall
  );

  yield takeLatest(
    "ClassSelectionDataReadSlice/ClassSelectionDataRead",
    ClassSlectionDataCall
  );

  // Booklet Tutor Dashboard
  yield takeLatest(
    "TutorDashboardStatusReadSlice/TutorDashboardStatusRead",
    TutorDashboardStatusCall
  );

  yield takeLatest(
    "TutorDashboardSummaryReadSlice/TutorDashboardSummaryRead",
    TutorDashboardSummmaryCall
  );

  yield takeLatest(
    "TutorDashboardClassesReadSlice/TutorDashboardClassesRead",
    TutorDashboardClassesCall
  );

  // tutor admin dashboard
  yield takeLatest(
    "TutorAdminDashboardReadSlice/TutorAdminDashboardRead",
    TutorAdminDashboardCall
  );

  yield takeLatest(
    "Tutoradmin_CalendarSlice/Tutoradmin_Calendar",
    TutorAdminDashboardCalenderCall
  );

  yield takeLatest(
    "AdminReprintSlice/AdminReprint",
    AdminreprintCall
  );

  // Reprint
  yield takeLatest("ReprintSlice/Reprint", ReprintCall);

  // ai drive search
  yield takeLatest("AiDriveSearchSlice/AiDriveSearch", AiDriveSearchCall);
  //#endregion Booklet

  // Booklet Admin Report

  yield takeLatest("ReportListSlice/ReportList", TutorAdminReportCall);
  yield takeLatest("ReportFilterSlice/ReportFilter", TutorAdminReportFilterCall);
  yield takeLatest("ReportReprintSlice/ReportReprint", TutorAdminReportReprintCall);

  // Booklet tutor Report
  yield takeLatest("TutorReportListSlice/TutorReportList", TutorReportCall);
  yield takeLatest("TutorReportFilterSlice/TutorReportFilter", TutorReportFilterCall);

  // Gate admin dashboard

  yield takeLatest(
    "GateAdminDashboardData/GateAdminDashboardData",
    GateAdminDashboardApiCall
  );

  yield takeLatest(
    "TestCompletedFilter/TestCompletedFilter",
    TestCompletedFilterCall
  );

  yield takeLatest(
    "OverallActivityFilter/OverallActivityFilter",
    OverallActivityFilterCall
  );

  yield takeLatest(
    "DashboardPrintlistSlice/DashboardPrintlist",
    DashboardPrintListCall
  );

  yield takeLatest(
    "TutorDashboardCalendarSlice/TutorDashboardCalendar",
    TutorDashboardCalenderCall
  );

  yield takeLatest("ActiveUserFilter/ActiveUserFilter", ActiveUserFilterCall);

  //#region CRM_ Modules

  yield takeLatest("LeadDataSlice/LeadDataRead", LeadDataCall);

  yield takeLatest("SessionReadSlice/SessionRead", SessionReadCall);

  yield takeLatest("Session_CrudSlice/Session_Crud", Session_CrudCall);

  yield takeLatest("ListVideoTutorialsSlice/listVideoTutorials", ListVideoTutorialsCall);
  yield takeEvery("AddVideoTutorialSlice/addVideoTutorial", AddVideoTutorialCall);
  yield takeEvery("EditVideoTutorialSlice/editVideoTutorial", EditVideoTutorialCall);
  yield takeEvery("DeleteVideoTutorialSlice/deleteVideoTutorial", DeleteVideoTutorialCall);

  yield takeLatest("ListVideoTutorialCategorySlice/listVideoTutorialCategory", ListVideoTutorialCategoryCall);
  yield takeEvery("AddVideoTutorialCategorySlice/addVideoTutorialCategory", AddVideoTutorialCategoryCall);
  yield takeEvery("EditVideoTutorialCategorySlice/editVideoTutorialCategory", EditVideoTutorialCategoryCall);
  yield takeEvery("DeleteVideoTutorialCategorySlice/deleteVideoTutorialCategory", DeleteVideoTutorialCategoryCall);

  yield takeLatest("TopicSelectionSlice/getTopics", GetTopicsCall);

  yield takeEvery(
    "ScheduledClassesSlice/getScheduledClasses",
    ScheduledClassesCall
  );

  yield takeEvery(
    "ScheduleSetupDataSlice/getScheduleSetupData",
    ScheduleSetupDataCall
  );

  yield takeLatest("CreateMeetLinkSlice/createMeetLink", CreateMeetLinkCall);
  yield takeLatest("CreateScheduledClassSlice/createScheduledClass", CreateScheduledClassCall);

  //#endregion Common Filter
}
